module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 1")])])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('strong', [_vm._v("DEFINITIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "txb"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cep"
  }, [_c('em', [_vm._v("Anger: The Good, the Bad, and the Destructive")])]), _vm._v(" "), _c('p', {
    staticClass: "cot"
  }, [_vm._v("Though most people don’t see themselves as angry, they do feel deeply frustrated and upset about past wrongs and hurts. Sometimes, without even realizing it, they become filled with hateful, bitter thoughts that churn deep inside.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So how can we recognize anger in ourselves and others? Consider the following:")])]), _c('div', {
    staticClass: "blockquote1"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "bp1"
  }, [_vm._v("• Angry people are quick-tempered, often lashing out in word or deed before they’re even aware of it. Their anger triggers instantly, and their anger ignites.")]), _vm._v(" "), _c('p', {
    staticClass: "bp1"
  }, [_vm._v("• Angry people hold on to their anger; they feel as angry today as when the anger-causing event happened. Perhaps you know just what I’m talking about. Are your tears just as quick to flow now as then? Does the pain in your heart sting just as much? Does the memory of an event still cause your hands and jaw to clench? If so, you too have been affected by our angry world.")])]), _c('p', {
    staticClass: "bp1"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("• Angry people justify their anger, so they have no problem holding a grudge. They make excuses for their anger and try to get others to agree that they have a “right” to be angry.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("If any of the above applies to you, own up to the fact that more than likely you are an angry person.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("God’s Word instructs us to be patient when we are wronged and long-suffering when we are hurt (1 Corinthians 13:4–5). Any other response to life’s painful moments is contrary to what the Lord desires for His children.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“But,” someone may say, “I’m not angry; I’d rather think of myself as just a little irritated or a little frustrated.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That may be true, because anger doesn’t feel the same to everyone. In fact, its definition may change depending on whom you ask.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Anger Defined")]), _vm._v(" "), _c('p', {
    staticClass: "txb"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txf1"
  }, [_vm._v("I define anger as a strong, intense feeling of displeasure, hostility, or indignation resulting from a real or imagined threat, insult, injustice, or frustration to you or others who are important to you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Let’s break down that definition phrase by phrase.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("Anger Is Intense")])]), _vm._v(" "), _c('p', {
    staticClass: "txfz"
  }, [_vm._v("Countless things in life can cause you to feel upset or frustrated. You discover your favorite shirt or blouse is missing a button. You break a glass as you hurry to fix breakfast. You sleep through your alarm clock ringing. Feelings of being “just a little mad” can set in. In the vast majority of cases, the irritation from these minor incidents disappears rather quickly. Real feelings of anger tend to remain until the cause is addressed, defeated, and eliminated. The intensity of that anger extends beyond the moment; it rules the day.")])]), _c('p', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('strong')]), _c('strong', [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Anger Is a Feeling")])])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "txfz"
  }, [_vm._v("It is a strong emotion that is often intertwined with other emotions. We need to be honest about our emotions. They are our frontline response to life. As much as a person may desire or strive to act and live in a rational, objective, and dignified manner, acting that way all the time is "), _c('em', [_vm._v("not")]), _vm._v(" realistic. We respond to life events first out of our emotions and with a very basic two-option determination—“I like this” or “I don’t like this.” We decide whether something is good or evil, right or wrong, helpful or harmful almost instantly. Most people make up their minds before they have the time or the opportunity to gather objective data and determine the best decision to make.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("God, who created every aspect of our being "), _c('em', [_vm._v("for our good,")]), _vm._v(" made us feel and express emotions. He created us with a capacity to feel love, joy, and peace. The Lord also allows us to experience frustration, hate, and fear. He gave us specific emotions to help us intuitively, instinctively, and immediately recognize danger, injustice, and evil intent.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If a person says to me, “I’m not emotional” or “I don’t want to be emotional,” I know something is not right. God intends for us to experience, express, and use our emotions to direct right behavior. They are intended to be triggers that prompt us to action, and our action is to be guided toward good and godly ends.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That is a major concept that I cannot overemphasize.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You have been given emotions so that "), _c('em', [_vm._v("by an act of your human will,")]), _vm._v(" you might be directed toward right behavior.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Your emotions are never to rule over you. You are to be the master of your responses and reactions. The person who allows himself to be ruled by emotions is on a continual roller coaster. He fails to resolve the issues that trigger an emotional response and is always pulled from one high to the next low. Such a person is easily swayed by others and very often “acts out” in inappropriate, unproductive, ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("or ungodly ways.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("We are to subject our emotions to our human will, which is also a gift that our Creator freely gives to each person for the purpose of making choices and decisions. The moment you feel an intense emotion, the first thing you need to do is ask, "), _c('em', [_vm._v("How should I respond?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Behavior always has an element of free will. We make willful, deliberate choices about what we do and don’t do, what we say and don’t say, and what attitudes and beliefs we hold on to.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Emotions can be random and unstable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Behavior is nearly always directed and measurable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This is not to say, of course, that all behavior is rational or predictable. The truth is that almost all emotional responses eventually end up coming out in words and deeds. The deeper we feel an emotion, the more compelled we feel to express it in a way that is observable to the outside world.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ideally, our emotions are filtered through a will that is bent toward God’s purposes and commandments. However, if the filter has been damaged or has never been put in place, emotions will usually give rise to behavior that is unchecked. Emotions that are not subject to godly thinking tend to run amok and cause great damage.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“But I like to be spontaneous,” a person may say.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I want to live free!” declares someone else.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I am a person of intense passion, and I can’t help but express it,” still another might say.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("People often make those statements when they see themselves as especially creative, artistic, entrepreneurial, innovative, or free-thinking. In truth, the person who is always ruled by emotions is far more likely to produce a creative mess, an entrepreneurial mistake, or an innovative disaster than something that is truly beautiful, wise, or beneficial.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Understanding that our emotions are a gift from God, and that we base behavior on filtered or unfiltered emotions, we must also realize that a lot of what you and I are going to feel will be negative. ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("No one has a 100 percent positive emotional response to life all the time and in all circumstances. We "), _c('em', [_vm._v("should")]), _vm._v(" have a negative response about some things:")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("When you come across a homeless person curled up on a sidewalk as the snow begins to fall …")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When you see a child whose face is drawn and belly swollen from malnutrition …")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When you hear the story of a battered wife and mother of small children forced to seek protection in a women’s shelter …")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There "), _c('em', [_vm._v("should")]), _vm._v(" be an emotional response that shouts from the depths of your soul: "), _c('em', [_vm._v("This is wrong! This is bad!")])]), _vm._v(" "), _c('p', {
    staticClass: "txh"
  }, [_vm._v("And out of that response should come a desire to "), _c('em', [_vm._v("change")]), _vm._v(" the situation.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("Anger Encompasses Other Feelings")])]), _vm._v(" "), _c('p', {
    staticClass: "txfz"
  }, [_vm._v("Emotions linked to anger are usually ones of displeasure, hostility, or indignation. All these are negative feelings, though that doesn’t necessarily mean they are wrong. They are legitimate emotions, but they don’t need to be expressed in negative behavior.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For example, you can dislike a situation yet not have strong feelings that the situation needs to change. You can dislike someone and not demand that the person be removed from your presence. You can be offended by something that’s said without feeling the need to speak up and set the record straight. On the other hand, you can dislike a situation and feel motivated to change it. You can respond to hostility with kindness and defuse it. You can confront critical comments and seek to establish truth and a sense of balance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Anger is the intense feeling that compels a person to act—to remove or resolve whatever is causing the intense displeasure, hostility, or indignation. It is the feeling that compels a person to flee or fight a real or imagined threat.")])]), _c('p', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('strong', [_vm._v("Anger Comes in Response to a Threat—"), _c('br')])]), _c('strong', [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Real or Imagined")])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "txfz"
  }, [_vm._v("Each of us has a built-in fight-or-flight response mechanism. This is a gift from God to us for our human survival. If you awaken while on a camping trip and see the shadow of a grizzly bear on your tent, you are likely to feel immediate fear and a compelling desire to run for your life. If you are on a high mountain trail and see something coiled on the path ahead, your response is likely to be “Snake!” not “Oh, a garden hose.” Your reaction is going to be immediate and emotional. Again, you will make an almost instinctive response to either fight or take flight.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("Anger Can Follow a Threat of Loss")])]), _vm._v(" "), _c('p', {
    staticClass: "txfz"
  }, [_vm._v("You can become angry over a threat aimed at you personally or at someone important to you. Ask any mother how she felt after learning that her child was threatened with unfair criticism or bullying, and she’s likely to say, “Angry!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We don’t even need to know people personally to feel anger toward a situation they are experiencing. We can become angry when we witness a group being treated unfairly as the result of prejudice or bigotry.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We may feel threatened by an emergency weather report that tells us a tornado or hurricane is headed in our direction. Or we may feel threatened when a large number of people at our school, workplace, or community are falling ill to a dreaded disease. However, we rarely respond to those types of threats with anger. An angry response is most likely generated when the threat comes from an identifiable person or group of people.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Several years ago a woman told me about an incident in the early years of her marriage. Her husband attended church, but it was more out of social obligation than genuine faith. He resented very deeply the growing faith of his wife.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("One day he noticed her Bible, which she had left open. He could clearly see how she had written notes in the margins and underlined ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("or highlighted certain passages of Scripture. The man picked up his wife’s Bible and threw it across the room. In anger, he shouted to her, “There will be no Bible study in this house!”")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("The woman was hurt. Her husband was angry. And at the core of it all, he felt threatened. He felt threatened out of a fear that the “religious crowd” would influence his wife. He also was afraid that through her, his life might change in ways he didn’t want. He was threatened in particular by the impact a few preachers were having on his wife through their sermons at church and on television.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The good news is that this man eventually came to have a desire for more of God. He began to read his own Bible and grew in his faith.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When this woman shared her story, I felt anger welling up in me!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How could a husband say and do those things? How could he so blatantly and willfully hurt his wife’s feelings? I felt anger on her behalf. I wanted to go to him and say, “How dare you do this!” My anger was focused on him because he had threatened someone who was sincerely and innocently seeking more of God.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now, this man had died a number of years before his wife told me her story—and I knew this when she began telling me her story. But it still made me angry.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You may be thinking, "), _c('em', [_vm._v("But you had no right to be angry.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, I did. My right to be angry wasn’t born of a relationship with this man or woman. But I had a right born of principle and of my beliefs and awareness of what God has declared is good and acceptable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You do not need to know an abused child to be angry at the problem of child abuse.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You do not need to know a battered woman to be angry at spousal abuse.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You do not need to know someone who has been the victim of a crime in order to be angry with criminals who are becoming more and more bold in threatening people.")])]), _c('p', {
    staticClass: "txh"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Not long ago, I had a conversation with a man who has more than forty years of marketing experience. He said, “One of the things I learned early on in my career of helping people through charitable giving is that you need to put a face to an injustice. You need a photo of a starving child, an impoverished family, or a homeless person by the side of the road. You need a forceful image that makes people not only feel sad about the situation or feel sorry for the victim, but makes them angry that somebody or some group allowed this to happen. And if you can identify the ‘somebody’ and put a face on the person who has created the bad situation, then the only thing left to do is point out what a person’s contribution can do to change the situation or remove the source of the problem. That is really a winning combination.”")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Unfortunately, many times it’s not just one person who creates the injustice. And sadly, there are countless situations in which many people are responsible for bad decisions and choices that lead to desperate needs and horrible circumstances. Even so, we should recognize this truth: When we are faced with a threat, we are wise to understand who is making it and why.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We are wise to ask:")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Is the threat real or imagined?")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Is it temporary or ongoing?")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Is it coming from an identifiable person or group?")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("The force behind a threat is the “enemy.” We need to know the enemy and make sure we are not it.")]), _vm._v(" "), _c('p', {
    staticClass: "h3a"
  }, [_vm._v("ANGER")]), _vm._v(" "), _c('p', {
    staticClass: "txb1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "bx5"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('table', {
    staticClass: "cl",
    attrs: {
      "border": "1",
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('strong', [_vm._v("Threat"), _c('br'), _vm._v("(Real or"), _c('br'), _vm._v("Imagined)")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Against Self or Someone Important to You")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Creates"), _c('br'), _vm._v("Feelings"), _c('br'), _vm._v("of Indignation,"), _c('br'), _vm._v("Displeasure,"), _c('br'), _vm._v("or Hostility")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Focused"), _c('br'), _vm._v("as ANGER")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Ideally"), _c('br'), _vm._v("Filtered"), _c('br'), _vm._v("Through Godly"), _c('br'), _vm._v("Human Will")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Producing"), _c('br'), _vm._v("BEHAVIOR that"), _c('br'), _vm._v("Resolves,"), _c('br'), _vm._v("Reconciles, or Removes"), _c('br'), _vm._v("the Threat")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("THREE CORE TRUTHS ABOUT ANGER")]), _vm._v(" "), _c('p', {
    staticClass: "txb"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txf"
  }, [_vm._v("In addition to a solid definition, we need to understand three core truths about anger and how it is manifested in our angry world.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("The Universality of Anger")])]), _vm._v(" "), _c('p', {
    staticClass: "txfz"
  }, [_vm._v("Anger is a universal emotion. It affects every person, regardless of race, sex, nationality, or age—from a screaming toddler to an elderly person red in the face with rage; from the wealthy businessman to the impoverished housewife; from the cold of the Arctic to the heat of the Sahara; from a war zone to a tropical paradise—anger is an emotion known to all people. Regardless of how peaceful or passive a person might seem or desire to be, everyone gets angry at some time in his or her life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But the fact that everyone gets angry is not a justification for it. The universality of anger is not an excuse for getting angry, nor is it an excuse for failing to deal with it or failing to direct it toward godly goals.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("The Persistence of Anger")])])]), _c('p', {
    staticClass: "txfz"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Anger will not go away on its own. It doesn’t die out. It must be ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("rooted out. Dealing with anger, especially deep-seated anger, requires intentionality.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("Episodic Anger Versus Pervasive Anger")])]), _vm._v(" "), _c('p', {
    staticClass: "txfz"
  }, [_vm._v("We are wise to differentiate between angry episodes and a pervasively angry nature.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Is there evidence that you are a chronically angry person? Are you angry about something nearly all the time, even if you wear a smile on your face and speak in a soft, calm voice?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There is a big difference between the person who feels anger as a response to a specific situation or circumstance, and the one whose anger doesn’t go away. If you are angry at the first step of a journey and are still angry a thousand miles later, you likely live with pervasive anger.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("IS ANGER A SIN?")]), _vm._v(" "), _c('p', {
    staticClass: "txb"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txf"
  }, [_vm._v("The apostle Paul wrote to the Ephesians, “Be angry, and yet do not sin” (Ephesians 4:26). He openly and directly admitted that anger exists, that it is part of everyone’s emotional makeup—even the most mature and spiritually minded person’s—and that we "), _c('em', [_vm._v("all")]), _vm._v(" get angry from time to time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Paul is also presenting the truth that anger, in and of itself, is not a sin. How we handle it and what we "), _c('em', [_vm._v("do")]), _vm._v(" with it is the key. So anger as an emotion is not necessarily sinful. Some situations and circumstances in life warrant our anger.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And you "), _c('em', [_vm._v("can")]), _vm._v(" be angry without sinning.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Rather than describing a person who is perpetually or pervasively angry as a sinner, the Bible describes him or her as")])]), _c('div', {
    staticClass: "blockquote1"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('p', {
    staticClass: "bp1"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('em', [_vm._v("• "), _c('strong', [_vm._v("A foolish person")])]), _vm._v(". Proverbs 14:17 tells us, “A quick-tempered ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("man acts foolishly.”")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "bp1"
  }, [_c('em', [_vm._v("• "), _c('strong', [_vm._v("A person likely to cause arguments and dissension")])]), _vm._v(". Proverbs 15:18 says, “A hot-tempered man stirs up strife, but the slow to anger calms a dispute.”")]), _vm._v(" "), _c('p', {
    staticClass: "bp1"
  }, [_c('em', [_vm._v("• "), _c('strong', [_vm._v("A person who should be avoided")])]), _vm._v(". We read in Proverbs 22:24, “Do not associate with a man given to anger, or go with a hot-tempered man, or you will learn his ways and find a snare for yourself.” The angry person is usually someone with a short fuse. Scripture is clear that a quick or hot temper is to be avoided.")]), _vm._v(" "), _c('p', {
    staticClass: "bp1"
  }, [_vm._v("• “He who is slow to anger is better than the mighty, and he who rules his spirit, than he who captures a city” (Proverbs 16:32).")]), _vm._v(" "), _c('p', {
    staticClass: "bp1"
  }, [_vm._v("• “Do not be eager in your heart to be angry, for anger resides in the bosom of fools” (Ecclesiastes 7:9).")])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Three principles are reflected in the verses above and in other parts of the Bible:")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("Principle 1: Avoid Associating with Angry People")])]), _vm._v(" "), _c('p', {
    staticClass: "txfz"
  }, [_vm._v("As stated above, Proverbs warns us, “Do not associate with a man given to anger” (22:24). I have quoted this verse to many people through the years—especially men and women as they prepare to marry and those who come to me for advice about business partners.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("One of the great descriptions of godly character is found in Galatians 5:22–23. Here Paul tells us, “The fruit of the Spirit is love, joy, peace, patience, kindness, goodness, faithfulness, gentleness, [and] self-control.” If you are considering a long-term relationship ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("with a person—in marriage, friendship, business, and so forth—I strongly encourage you to evaluate your relationship with that person on the basis of this fruit.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("A few verses earlier, the apostle Paul warns everyone to avoid “deeds of the flesh.” His list includes behaviors that are either variations of anger or somehow associated with it. They are “immorality, impurity, sensuality, idolatry, sorcery, enmities, strife, jealousy, outbursts of anger, disputes, dissensions, factions, envying, drunkenness, carousing and things like these” (Galatians 5:19–21).")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If you are considering entering into a relationship with someone, I strongly encourage you to subject your character and the other person’s to Paul’s template of behavioral traits.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There simply is nothing good to be gained from linking yourself with an angry person. Choose instead someone who bears the characteristics of spiritual maturity.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A young woman once said to me in a marriage-counseling session many years ago, “I like the fact that Herb is so passionate about what he believes. I see his anger as a strength. He stands up to people who are sinning or mistreating other people.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I replied, “You won’t see this as a strength when he begins to believe that something "), _c('em', [_vm._v("you")]), _vm._v(" are doing is wrong or inappropriate.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The more she described some of Herb’s “passionate” outbursts in defense of his own opinions, the more I saw trouble ahead for this young woman. So I advised her to postpone her marriage until Herb could get counseling to help him deal with the root of his anger.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She did not take my advice but admitted five years later that she wished she had. Herb had become increasingly angry and vocal in just about every area of his life—at work, in church meetings, in their home, at political rallies, and in their relationships with their neighbors.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("One of the things I noticed when this woman admitted feeling ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("caught in a trap was that "), _c('em', [_vm._v("she")]), _vm._v(" seemed angry herself.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("I told her, “Don’t let your husband’s anger infect your sweet personality.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She said, with a tone of sadness in her voice, “Oh, Dr. Stanley, I think it already has. I am very angry with Herb. Some weeks it seems I’m mostly angry with him and not very loving. His anger has worn me out and is infecting our two-year-old daughter. I feel upset every waking hour.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Again, I recommended counseling to her. And this time, she and Herb did seek out a godly counselor. They began to address the deep problems underlying Herb’s anger, as well as to explore how she could address and overcome her developing feelings of anger.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The truth is, in the majority of cases, it is far more likely for a hot-tempered person to influence a peaceful, nurturing individual than the other way around. It is difficult for the peaceful person to change the basic nature of one who is quick-tempered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As a person once said to me, “It is a lot easier to get riled up than to get calmed down.”")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("Principle 2: Anger Is Linked to Foolishness")])]), _vm._v(" "), _c('p', {
    staticClass: "txfz"
  }, [_vm._v("The Bible associates anger with foolish behavior. Why? Because the hot-tempered or quick-tempered person rarely has the discipline or takes the time to make wise, informed, rational decisions. The angry person is impetuous and acts instinctively. And, generally speaking, that kind of behavior has a far greater chance of being problematic and harmful than purposeful and helpful.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Our language is filled with phrases that depict quick-tempered behavior:")])]), _c('div', {
    staticClass: "blockquote1"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "bp1"
  }, [_vm._v("• Fly off the handle")])]), _c('p', {
    staticClass: "bp1"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("• Knee-jerk reaction")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "bp1"
  }, [_vm._v("• Blow your top")]), _vm._v(" "), _c('p', {
    staticClass: "bp1"
  }, [_vm._v("• Let off steam")])])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("All these indicate that the angry person tends to act before he has a chance to think. His behavior is faster than his brain. A person who is caught up in any emotion, especially anger, doesn’t take the time to weigh all his options or consider all the consequences. The end result is often foolishness, which by its very definition means a lack in judgment and a ridiculous appearance.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("Principle 3: An Unruly Spirit Rules Poorly")])]), _vm._v(" "), _c('p', {
    staticClass: "txfz"
  }, [_vm._v("Let me give you a little insight into the verse that says, “He who is slow to anger is better than the mighty, and he who rules his spirit, than he who captures a city” (Proverbs 16:32).")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Many powerful warriors and political rulers in the ancient world were men prone to anger. They tended to “look for a fight” to prove themselves as leaders. Anger was perceived as almost a given trait for those who became “mighty.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("God’s Word says that the person who is "), _c('em', [_vm._v("slow")]), _vm._v(" to anger should be in authority. The individual who can rule his own spirit can be trusted to take a disciplined, measured approach in ruling others. Furthermore, while a pompous, power-hungry, anger-driven person may capture a people or a city, he rarely has the wisdom and demeanor to successfully manage or maintain control. He is unable to lead and empower his people to be productive and prosperous.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Angry leaders tend to zap the resources of those they govern. An appetite for power often devours everything in its wake. The slow-to-anger person is the one who has a much better opportunity for nurturing growth and stability. This is true in family, church, ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("business, and political settings, as well as almost any other setting you can imagine.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "h3"
  }, [_vm._v("ANGER SURFACES AS BEHAVIOR")]), _vm._v(" "), _c('p', {
    staticClass: "txb"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txf"
  }, [_vm._v("Although it’s an emotion, anger almost always surfaces as "), _c('em', [_vm._v("behavior")]), _vm._v(". It is seldom contained within the person who is angry. Anger usually finds a way to display itself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the fourth chapter of Ephesians, the apostle Paul urges believers to avoid sinning in their anger and to deal with it before the sun goes down. Then he wrote this: “Do not give the devil an opportunity” (verse 27).")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To what “opportunity” is Paul referring? It is the opportunity for the devil to influence the way you express your anger and the way you justify its cause and the behavior that follows.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Let me assure you that the devil will tempt you to display your anger in the meanest, vilest, and most vindictive way possible. Satan wants you to get away with being angry. He wants you to have your say and win the day, so to speak. He wants you to inflict as much pain as possible on the person to whom you are speaking or lashing out. He wants the consequences to be as severe as possible. And the Enemy’s lie is that if you treat the other person in the worst possible way, he or she will never seek to injure or criticize you in the future.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The devil is quick to help scheme or devise ways to display anger so you can appear very witty in your use of sarcastic language, or so you may appear extremely cool, calm, and collected in your demeanor. Satan wants you to look good while being as damaging as possible to another person’s heart and mind.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Let me also warn you—the devil will present all sorts of arguments for you to justify why you lashed out in anger. They include telling ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("you that the other person “deserved” your angry tirade and that the other person would not have been punished for her hurtful behavior by anyone else if you hadn’t reacted and taken action.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s a pack of lies. But the person who holds on to his or her anger is often incapable of discerning lie from truth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I once had a conversation with a person who seemed to be taking great pride in telling me all he had said to someone he said was persecuting him. He was almost bragging about his angry, hateful behavior as he said, “I really put him in his place.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I asked, “Did he stay there?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The man was startled. He paused for a moment and then said, “No, not for very long.”")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("ANGRY WORDS ARE ANGRY DEEDS")]), _vm._v(" "), _c('p', {
    staticClass: "txb"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txf"
  }, [_vm._v("Angry behavior is not limited to violent deeds, flying fists, or thrown objects. Angry words "), _c('em', [_vm._v("are")]), _vm._v(" a form of angry deed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When we speak angry words without any concern for the consequences associated with them, we are reflecting immaturity and a callous nature. It demonstrates a lack of love and caring for others.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We live in a time, of course, when many people do not want to talk about consequences. They would rather not be responsible for anything negative that results from something they do or say. They prefer to say whatever they want and let the hearer deal with it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The truth is that all words have an impact of some kind and to some degree. What we say matters. Words have meaning, and what we say sends a message that hits both the head and the heart. Our words trigger both ideas and emotions in all who hear—and overhear.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Who you are today, right this moment, is a consequence of what ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("happened yesterday—and all the yesterdays before it. Your very nature and character are composites of all that you have said and done in the past and all that others have said and done to you in the past.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Where you will be tomorrow will be a consequence of what you say and do today as well as how you internalize what others around you say and do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("None of us is immune to the impact of others’ words and actions. Much of what happens to you and me is directly linked to our use of words and the choices and decisions we have conveyed through what we say.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A woman once told me that she felt entirely justified after blasting her supervisor with an angry tirade of critical comments and accusations. “If I hadn’t said it, nobody would have, and she would have continued in her hurtful and prejudicial behavior without any consequences.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Where is that woman today?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I don’t know,” she said. “I no longer work there.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Why not?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Because nothing happened to my supervisor. She didn’t change, and nobody in upper management cared.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The energy expended in a negative outburst rarely produces a positive result. I found myself asking later, “What "), _c('em', [_vm._v("might")]), _vm._v(" have happened if this woman had put the same amount of energy into praying for her supervisor and getting to know the woman a little better?” That may have opened the door for a positive conversation with her supervisor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Angry words rarely have long-lasting influence. In this woman’s case, her anger led to resentment, disillusionment, and the loss of a job. It had no apparent impact on the person who needed to make changes but likely rejected the entire outburst.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("You may think you are settling a score when you erupt at another ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("person. In nearly all cases, you are still going to lose the game.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“But I feel so much better when I get things off my chest,” a man said to me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Do you really?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Oh, yes! I feel great.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How long does that good feeling last?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He paused and then said, “Right up until bedtime, when I realize that I’m sleeping on the couch.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Anger expressed in words always has consequences, and they are usually just as severe as anger expressed physically.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('em', [_vm._v("Monitor all that you say")]), _vm._v(". I vividly remember the first time I felt anger in my heart. I was about four years old. Certainly I may have manifested anger before that, but I didn’t "), _c('em', [_vm._v("know")]), _vm._v(" I was angry then. This time, I "), _c('em', [_vm._v("knew")]), _vm._v(" I was burning hot on the inside as I insisted on having my way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The incident was not particularly earth-shaking. My mother was getting ready to walk into town, and she told me to stay at home and wait for her to return. But I wanted to go with her, not wait for her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I made a major fuss. And although I’m sure my vocabulary wasn’t developed enough at that point to fully express all that I was feeling inside, I am also sure I knew enough words to let my mother know with full force that I did not like her decision, did not agree with her decision, and did not intend to obey her decision. I wanted to go with my mother!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I also remember vividly what happened. My mother turned to me, looked me directly in the eyes, and said, “A gentle answer turns away wrath, but a harsh word stirs up anger.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I didn’t know my mother was quoting Proverbs 15:1, and I’m not sure if she knew either. But in that moment, I did know—and fully understood—that she was speaking truth to me. Her gentle voice matched her message and defused my anger on the spot.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Even though I was only four years old, I immediately felt ashamed and sat down to quietly await my mother’s return.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("As I have reflected upon that incident throughout my life, I remain absolutely convinced that it is not only "), _c('em', [_vm._v("what")]), _vm._v(" we say that matters but "), _c('em', [_vm._v("how")]), _vm._v(" we say it. Words spoken with gentleness can quiet an angry heart. Words spoken with harshness—or with a stern, prideful, cynical, or critical edge—stir up anger.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("You may think your harsh words anger only the person to whom you are speaking. But your harsh words stir up anger in "), _c('em', [_vm._v("you")]), _vm._v(" as well. It’s as if your opinions about the other person become solidified in your own heart as you speak harshly. The net result is that a negative attitude takes firmer root in you. Once you have spoken harshly to a person, it becomes much easier to speak harshly to him or her in the future. You’re also more likely to talk that way to others who irritate or frustrate you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But not all our harsh words are spoken to the people around us. Most of the time, we save the worst criticism for ourselves.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Just about everyone I know talks to himself or herself throughout the day. Sometimes our self-talk is a form of self-instruction. We remind ourselves how to perform a specific task or not to forget something important. We may be encouraging ourselves to control our own attitudes and behavior. But many times, self-talk takes on the form of self-criticism.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Do you speak to yourself in gentle tones—encouraging yourself to do better and to live according to the highest and most noble standard?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Or do you put yourself down and speak words of criticism and judgment over yourself?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Very often, the harshness of a person’s own words becomes the fuel that keeps the embers of anger burning.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Before you marry someone, be sure to meet his or her family. Pay attention to the dynamics of their communication with one another. Do tempers flare? Are arguments frequent and heated? Do disputes and debates erupt at every mealtime? Be sure that none of the negative traits you witness have taken hold in the person you’re ")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("dating. If they have, walk away.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "h3"
  }, [_vm._v("THE PATH TO PEACE")]), _vm._v(" "), _c('p', {
    staticClass: "txb"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txf"
  }, [_vm._v("Why is it so important that we recognize and deal with anger? Because until we do, we will never find the peace that we all so desperately seek.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Only when we "), _c('em', [_vm._v("admit")]), _vm._v(" and "), _c('em', [_vm._v("deal with")]), _vm._v(" anger can we truly live in peace with ourselves and others.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Through the years, I have discussed the issue of anger with many, many people and have drawn these two conclusions:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote1"
  }, [_c('p', {
    staticClass: "bp1"
  }, [_vm._v("• Some people admit to feeling deep-seated anger, but their response is “I don’t want to deal with it.” That means they don’t want to explore the causes or extent of their anger in order to be set free from it. If they have any concern at all, it is about how to control or “manage” their anger. They have virtually no interest in exploring ways to rid themselves of the displeasure, hostility, and indignation that have taken root deep within. They are "), _c('em', [_vm._v("suppressing")]), _vm._v(" anger.")]), _vm._v(" "), _c('p', {
    staticClass: "bp1"
  }, [_vm._v("• Other people refuse to admit they are angry, even though a variety of observable indicators suggests otherwise. Their family members see them as being angry. Their coworkers consider them to be angry. Pastors and fellow church members think they are angry. But remarkably, these angry people refuse to see the anger in themselves. They are in denial. They are "), _c('em', [_vm._v("repressing")]), _vm._v(" anger.")])])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("The most destructive anger is that which is resident but not recognized or addressed. Anger does not just lie dormant in a ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("person. If it is present, it is active. It is fermenting and fomenting, and eventually, it will find expression.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("There are no advantages to suppressing or repressing anger.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "h3"
  }, [_vm._v("ADMIT IT—DEAL WITH IT")]), _vm._v(" "), _c('p', {
    staticClass: "txb"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txf1"
  }, [_vm._v("Consider each question below. You might find it helpful to use a journal to answer these and the ones at the end of each chapter.")]), _vm._v(" "), _c('p', {
    staticClass: "box"
  }, [_vm._v("1. Are you currently angry with a person? If so, can you identify who that person is?")]), _vm._v(" "), _c('p', {
    staticClass: "box"
  }, [_vm._v("2. Is the anger rooted in a justifiable cause—one that is consistent with God’s commandments and His purposes here on earth?")]), _vm._v(" "), _c('p', {
    staticClass: "box"
  }, [_vm._v("3. Is your anger seeking vengeance? In other words, are you seeking to get even with the person?")]), _vm._v(" "), _c('p', {
    staticClass: "box"
  }, [_vm._v("4. Is the anger cherished?")]), _vm._v(" "), _c('p', {
    staticClass: "box"
  }, [_vm._v("5. Is the anger associated with an unforgiving spirit?")]), _vm._v(" "), _c('p', {
    staticClass: "box-tx"
  }, [_vm._v("If your heart answered “yes” to most of these questions, your anger has the potential to destroy you. Choose to admit your anger and deal with it "), _c('em', [_vm._v("now")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c62556b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 69
// module chunks = 0